import Vue from 'vue';
import Router from 'vue-router';
import VueHighlightJS from 'vue-highlightjs'
import Install from '@/components/install';
import Theme from '@/components/theme';
import Icon from '@/components/icon';
import Buttons from '@/components/buttons';
import Popover from '@/components/popover';
import Tabs from '@/components/tabs';
import TabBar from '@/components/tab-bar';
import Checkbox from '@/components/checkbox';
import Radio from '@/components/radio';
import Input from '@/components/input';
import Picker from '@/components/picker';
import Switch from '@/components/switch';
import Search from '@/components/search';
import Notice from '@/components/notice';
import Loading from '@/components/loading';
import Action from '@/components/action'
import Modal from '@/components/modal'
import Toast from '@/components/toast'
import Result from '@/components/result'
import Refresh from '@/components/refresh'


Vue.use(Router);
Vue.use(VueHighlightJS);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'install',
      component: Install,
    },
    {
      path: '/notification',
      name: 'notification',
      component: Notification,
    },
    {
      path: '/install',
      name: 'install',
      component: Install,
    },
    {
      path: '/theme',
      name: 'theme',
      component: Theme,
    },
    {
      path: '/icon',
      name: 'icon',
      component: Icon,
    },
    {
      path: '/button',
      name: 'buttons',
      component: Buttons,
    },
    {
      path: '/popover',
      name: 'popover',
      component: Popover,
    },
    {
      path: '/tabs',
      name: 'tabs',
      component: Tabs,
    },
    {
      path: '/tab-bar',
      name: 'tab-bar',
      component: TabBar,
    },
    {
      path: '/checkbox',
      name: 'checkbox',
      component: Checkbox,
    },
    {
      path: '/radio',
      name: 'radio',
      component: Radio,
    },
    {
      path: '/input',
      name: 'input',
      component: Input,
    },
    {
      path: '/picker',
      name: 'picker',
      component: Picker,
    },
    {
      path: '/switch',
      name: 'switch',
      component: Switch,
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice,
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading,
    },
    {
      path: '/action',
      name: 'action',
      component: Action,
    },
    {
      path: '/modal',
      name: 'modal',
      component: Modal,
    },
    {
      path: '/toast',
      name: 'toast',
      component: Toast,
    },
    {
      path: '/result',
      name: 'result',
      component: Result,
    },
    {
      path: '/refresh',
      name: 'refresh',
      component: Refresh,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js